export default __webpack_public_path__ + "static/media/unsubscribe.210c4ec0.png";